import React from 'react';

import { Box } from '@chakra-ui/react';

import BaseImage from '../Base/BaseImage/BaseImage';

const WhatsappClip = () => {
  return (
    <Box
      as={'a'}
      href={'https://api.whatsapp.com/send?phone=971502460687'}
      target='_blank'
      rel='noreferrer'
      pos='fixed'
      right='0'
      top='50%'
      w='60px'
    >
      <BaseImage
        src={'/assets/img/yacht/whatsapp-clip.png'}
        alt='Send us message on WhatsApp'
        dimensions={[64, 82]}
        priority={true}
      />
    </Box>
  );
};

export default WhatsappClip;
